import { responseStatus } from "../constants/index";

const { SUCCESS } = responseStatus;

//Function to handle http response from server and perform action accordingly
async function handleHTTPResponses(httpResponse) {
  const data = httpResponse?.data;
  if (data) {
    return Promise.reject(data.message);
  }
}

async function handleStoreFrontHTTPResponses(httpResponse) {
  const data = httpResponse?.data;
  if (data) {
    return Promise.reject(data);
  }
}

//Handles server response
async function handleServerResponse(res) {
  const response = await res;
  if (response?.status === SUCCESS) {
    return response.data.items;
  }
  return;
}

const responseHandler = {
  handleHTTPResponses,
  handleServerResponse,
  handleStoreFrontHTTPResponses,
};

export default responseHandler;
